module.exports = __webpack_public_path__ + "img/embaixador-global.bb9934ed.png";